import * as React from 'react';

export const CompetenciesTab = () => {
  return <div>TBA tab content: CompetenciesTab</div>;
};
